export default class OnMouseEnter {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // cibler la section si elle a bg-mouseEnter-js + tous ses enfants
    const initialTargets = [];

    // 1️⃣ Si la section elle-même a bg-mouseEnter-js
    if (this.section.classList.contains('bg-mouseEnter-js')) {
      initialTargets.push(this.section);
    }

    // 2️⃣ Tous les enfants avec bg-mouseEnter-js
    initialTargets.push(...this.section.querySelectorAll('.bg-mouseEnter-js'));

    this.addListeners(initialTargets);
    this.observe();
  }

  addListeners(elements) {
    elements.forEach((el) => {
      if (el.dataset.hoverAttached) return; // éviter double attach
      el.dataset.hoverAttached = true;

      el.addEventListener('mouseenter', () => el.classList.add('entered'));
      el.addEventListener('mousemove', (e) => this.onMouseMove(e, el));
      el.addEventListener('mouseleave', () => el.classList.remove('entered'));
    });
  }

  observe() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return; // Element nodes uniquement
          // 1️⃣ node lui-même
          if (node.classList.contains('bg-mouseEnter-js')) {
            this.addListeners([node]);
          }
          // 2️⃣ ses enfants
          const children = node.querySelectorAll('.bg-mouseEnter-js');
          if (children.length > 0) {
            this.addListeners(children);
          }
        });
      });
    });

    observer.observe(this.section, { childList: true, subtree: true });
  }

  onMouseMove(e, el) {
    const rect = el.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    el.style.setProperty('--x', `${x}%`);
    el.style.setProperty('--y', `${y}%`);
  }
}
